module.exports = __webpack_public_path__ + "img/effective-negotiator.e06dd96a.svg";